<app-modal-header (closeModal)="close()"> </app-modal-header>
@defer (when reasons.length > 0) {
  <app-modal-body>
    <h1 class="fs-5 text-truncate pe-2" [innerHTML]="'HOLD_ON' | translate"></h1>
    <p>
      {{
        (isChatCancellation ? 'DO_YOU_REALLY_WANT_TO_LEAVE_THIS_CHAT' : 'DO_YOU_REALLY_WANT_TO_CANCEL_THIS_MEETING')
          | translate
      }}
    </p>
    <select name="reason" class="form-select" [(ngModel)]="reasonSelected" (change)="onChangeReason($event)">
      @for (value of reasons; track $index) {
        <option [value]="$index">{{ value }}</option>
      }
    </select>
    @if (reasonSelected === reasons.length - 1) {
      <div class="mt-2">
        <label for="otherReason" class="form-label">
          <i class="ri-arrow-down-s-line fs-5"></i>
          {{ otherReason.length }}/100
        </label>
        <textarea
          [(ngModel)]="otherReason"
          class="form-control no-resize"
          id="otherReason"
          name="otherReason"
          rows="3"
        ></textarea>
        @if (otherReason.length > 100) {
          <p class="mb-0 text-danger fs-13px mt-2">
            {{ 'PLEASE_KEEP_YOUR_MESSAGE_TO_X_LETTERS' | translate: { length: 100 } }}
          </p>
        }
      </div>
    }
  </app-modal-body>
  <app-modal-footer classList="d-flex {{ !isExternalMode ? 'justify-content-center' : 'justify-content-start' }}">
    <button
      class="btn btn-primary rounded-5 {{ isExternalMode ? 'm-0' : '' }}"
      (click)="cancelMeeting()"
      [disabled]="activeButton === ActiveButton.CANCEL_MEETING && isHttpRequestRunning"
    >
      @if (activeButton === ActiveButton.CANCEL_MEETING && isHttpRequestRunning) {
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      }
      {{ (isChatCancellation ? 'LEAVE_CHAT' : 'CANCEL_MEETING') | translate }}
    </button>

    @if (!isExternalMode) {
      <button
        class="btn rounded-5"
        (click)="close()"
        [class.btn-outline-dark]="!isBgDarkMode"
        [class.btn-outline-light]="isBgDarkMode"
      >
        {{ 'NO_GO_BACK' | translate }}
      </button>
    }
    @if (errorMessage) {
      <div class="d-flex justify-content-center w-100">
        <span class="text-danger mt-2">{{ errorMessage | translate }}</span>
      </div>
    }
  </app-modal-footer>
} @placeholder {
  @if (isShowPlaceholder) {
    <app-modal-body>
      <div class="d-flex flex-column gap-3 mt-5">
        @for (item of [].constructor(4); track $index) {
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '30px',
            }"
          />
        }
      </div>
    </app-modal-body>
  }
}
